import CustomButton from '../common/buttons/custom-button';

import { useShowPhoneButton } from './useShowPhoneButton';

import useStyles from './ShowPhoneButton.styles';
import { Box, Typography } from '@material-ui/core';

export function ShowPhoneButton() {
  const { lang, handleOnClick } = useShowPhoneButton();
  const _classes = useStyles();
  return (
    <Box
      component='div'
      className={_classes.phoneButton}
      onClick={handleOnClick}
    >
      <Typography component='p' className={_classes.phoneButtonText}>
        {lang.callUser}
      </Typography>
    </Box>
  );
}
